import { Controller } from "@hotwired/stimulus"

const CARD_SUFFIX = "-POSTCARD"
const STICKER_SUFFIX = "-STICKER"

export default class extends Controller {
  static get targets() { return ["sku", "cardSku", "stickerSku"]; }

  derive() {
    this.applySuffix(this.cardSkuTarget, CARD_SUFFIX);
    this.applySuffix(this.stickerSkuTarget, STICKER_SUFFIX);
  }

  // Keep deriving only while the field still looks derived. Once the user has given it a suffix of
  // their own it belongs to them, and a later edit to the bundle SKU must not clobber it.
  applySuffix(target, suffix) {
    if (target.value.endsWith(suffix) || target.value === "") {
      target.value = `${this.skuTarget.value}${suffix}`;
    }
  }
}
